'use client';

import axios from "axios";
import { reportClientError, addBreadcrumb } from "@/utils/clientErrorReporter";

const axiosInstance = axios.create();


axiosInstance.interceptors.request.use(
  (config) => {
    try {
      // lightweight breadcrumb
      addBreadcrumb({
        type: "http.request",
        method: config?.method,
        url: config?.url,
      });

      // trace id header (best effort)
      const traceId = (() => {
        try { return sessionStorage.getItem("client_trace_id"); } catch { return null; }
      })();
      config.headers = config.headers || {};
      if (traceId) config.headers["x-client-trace"] = traceId;

      // timing
      config.metadata = { start: Date.now() };
    } catch {
      // intentionally ignored
    } return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      error.name = "Sesión Expirada";
      error.message = "Por favor, inicie sesión nuevamente";

      // Guardar la ruta actual en sessionStorage
      try {
        sessionStorage.setItem(
          "postLoginRedirect",
          window.location.pathname + window.location.search,
        );
      } catch  {
        // intentionally ignored
      }

      // Redirigir a logout o login
      window.location.href = "/auth/logout";
    }
    try {
      const meta = error?.config?.metadata;
      const durationMs = meta?.start ? Date.now() - meta.start : null;

      reportClientError({
        kind: "http.error",
        error,
        context: {
          durationMs,
          request: {
            url: error?.config?.url,
            method: error?.config?.method,
            baseURL: error?.config?.baseURL,
            params: error?.config?.params,
          },
          response: {
            status: error?.response?.status,
            statusText: error?.response?.statusText,
            data: error?.response?.data,
            headers: error?.response?.headers,
          },
        },
      });
    } catch  {
      // intentionally ignored
    } return Promise.reject(error);

  },
);

export default axiosInstance;
